import { SupplyWalkEditableContainer } from "./container";

export const SupplyWalkEditablePage = () => {
  return <SupplyWalkEditableContainer />;
};
